<template>
  <div class="relative inline-block text-left">
                    <div>
                      <span class="rounded-md shadow-sm">
                        <button  @click="toggle()" type="button" class="inline-flex justify-center w-full px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800" id="options-menu" aria-haspopup="true" aria-expanded="true">
                          Azioni
                          <svg class="w-5 h-5 ml-2 -mr-1" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                          </svg>
                        </button>
                      </span>
                    </div>

                    <!--
                      Dropdown panel, show/hide based on dropdown state.

                      Entering: "transition ease-out duration-100"
                        From: "transform opacity-0 scale-95"
                        To: "transform opacity-100 scale-100"
                      Leaving: "transition ease-in duration-75"
                        From: "transform opacity-100 scale-100"
                        To: "transform opacity-0 scale-95"
                    -->

                     
                    <div v-if="open" class="absolute right-0 z-10 w-56 mt-2 origin-top-right rounded-md shadow-lg">
                      <div class="bg-white rounded-md shadow-xs" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <div class="py-1">
                          <span :key="option.slug" v-for="option in options[typeOption]" @click="editStatus(option.slug)"  class="block px-4 py-2 text-sm leading-5 text-gray-700 cursor-pointer hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem" v-html="option.label">
                            </span>
                        </div>
                        <div class="border-t border-gray-100"></div>
                        <div class="py-1">
                            <button @click="edit()" type="submit" class="block w-full px-4 py-2 text-sm leading-5 text-left text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">
                              Modifica
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
</template>

<script>
export default {
    name: 'OrderDropDown',
    props: {
        order:{
            type: Object,
            required: true
        },
        typeOption:{
            type: String,
            required: true
        },
        modalOrder:{
            type: Object
        }
        
    },
    data() {
        return {
            total:null,
            showTotal:true,
            open: false,
            options:{
                type1: 
                [
                    {
                        label: 'Approva',
                        slug: 'approved'
                    },
                    {
                        label: 'Rifiuta',
                        slug: 'rejected'
                    },
                    {
                        label: 'Elimina',
                        slug: 'delete'
                    }
                ],
                type2: 
                [
                    {
                        label: 'In lavorazione',
                        slug: 'in-progress'
                    },
                    {
                        label: 'Completato',
                        slug: 'completed'
                    },
                    {
                        label: 'Rifiuta',
                        slug: 'rejected'
                    },
                    {
                        label: '<span class="text-xs">Sposta in</span> Da approvare',
                        slug: 'waiting'
                    },
                    {
                        label: 'Elimina',
                        slug: 'delete'
                    }
                ],
                type3: 
                [
                    {
                        label: 'Elimina',
                        slug: 'delete'
                    }
                ]
            }
        }
    },

    methods:{

        /*
        toogleDropDownOrder(order){
            if (order.showDrop == undefined){
                this.$set(order, 'showDrop', true);
            } else {
                order.showDrop = !order.showDrop;
            }
        },
        */

        toggle() {
            this.open = !this.open;
        },

        close(e) {
            if (! this.$el.contains(e.target)) {
                this.open = false;
            }
        },

        edit(){
            this.$emit('childToParent', this.order);
            this.open = false;
        },

        editStatus(slug){
            this.$emit('changeStatus', this.order, slug);
            this.open = false;
        }
    },

    created() {
        window.addEventListener('click', this.close)
    },

    mounted(){
        
    },

    beforeDestroy() {
        window.removeEventListener('click', this.close)
    },
}
</script>

<style>

</style>